import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SliceStatus } from "../../interfaces/Redux";

import { get } from "../../services/http";
import { getOrgShortName } from "../../services/authservice";

export interface OnboardingStatus {
  packageName: string;
  steps: OnboardingSteps[];
  onboardingCompleteModalSeen: boolean;
  pendingRegistration: boolean;
  registrationStepsComplete: boolean;
}

export interface OnboardingSteps {
  index: number;
  onboardingStep: string;
  packageName: string;
  required: boolean;
  skipped: boolean;
}

export interface OnboardingState {
  onboardingStatus: OnboardingStatus;
  status: SliceStatus;
  error?: string | undefined;
}

const onboardStatusDefaults = {
  packageName: "",
  steps: [],
  onboardingCompleteModalSeen: true,
  pendingRegistration: false,
  registrationStepsComplete: false,
  tempPassword: "",
};

const initialState: OnboardingState = {
  onboardingStatus: onboardStatusDefaults,
  status: SliceStatus.idle,
  error: "",
};

export const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    resetOnBoarding: () => initialState,
    setHasSeenModal: (state) => {
      state.onboardingStatus.onboardingCompleteModalSeen = true;
    },
    setRegistrationStepsComplete: (state) => {
      state.onboardingStatus.registrationStepsComplete = true;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOnboarding.pending, (state) => {
        state.status = SliceStatus.loading;
        state.error = undefined;
      })
      .addCase(fetchOnboarding.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = SliceStatus.succeeded;
          state.onboardingStatus = action.payload.onboardingResponse;
          state.error = undefined;
        }
      })
      .addCase(fetchOnboarding.rejected, (state, action) => {
        state.status = SliceStatus.failed;
        state.error = action.error.message;
      });
  },
});

export const fetchOnboarding = createAsyncThunk(
  "onboarding/fetchOnBoardingStatus",
  async () => {
    const { data } = await get(
      `api/onboarding/steps?packageName=${getOrgShortName()}`
    )
    .catch((response) => {
      throw new Error(response.message);
    });
    
    return {
      onboardingResponse: data,
    };
  }
);

export const {
  setHasSeenModal,
  resetOnBoarding,
  setRegistrationStepsComplete,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
